import styled from "styled-components"
import { 
    // COLOR,
    // FONT
 } from 'assets'
 
export const RefundDetailContainerStyled = styled.div`
/*===============================================
 Container 
===============================================*/
    
/*===============================================
Theme 
===============================================*/

`